import { useUBL } from '@common/log-manager';

export const useExclusiveBannerUBL = () => {
  const sendUBL = useUBL();

  const bannerImpressionUBL = (object_id: string) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'department_entry_banner',
      object_type: 'banner',
      object_id,
    });
  };

  const bannerClickUBL = (object_id: string) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'department_entry_banner',
      object_type: 'banner',
      object_id,
    });
  };

  return {
    bannerImpressionUBL,
    bannerClickUBL,
  };
};
